import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import i18n from "./i18n/i18n";
import { I18nextProvider } from "react-i18next";

navigator.serviceWorker
  .register(`${process.env.PUBLIC_URL}/eya-service-worker.js`)
  .then((registration) => {
    console.log("ServiceWorker registered with scope:", registration.scope);
  })
  .catch((error) => {
    console.error("ServiceWorker registration failed:", error);
  });
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
